module.exports = __webpack_public_path__ + "static/media/storybook.502d09ae.png";